import request from '@/helpers/request'

export default {
  async index() {
    return await request.get('program_category')
  },
  async show(categoryId) {
    return await request.get('program_category/' + categoryId)
  }
}

